export default __webpack_public_path__ + "static/media/back-arrow.f76c1a42.svg";